/* Casino page data — a realistic subset of the reference (real game names parsed
   from the casino DOM), structured for a live API later. Shape:
     categories (L1) → subtabs (L2, each w/ an int_tab_icons icon) → games (csn_thumb).
   Game thumbs point at /images/reddy/casino/{slug}.webp and the L2 icons at
   /images/reddy/int_tab_icons/{slug}.png — both live-server-only, so they degrade
   to a clean placeholder via onError (see GameTile / SubTabs). */
import { IMG } from './homeData';

const CASINO_IMG = `${IMG}/casino`;
const INT_ICON = `${IMG}/int_tab_icons`;

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const g = (name) => ({ name, img: `${CASINO_IMG}/${slug(name)}.webp` });
/* one L2 sub-tab: label + int_tab_icons icon + its games */
const sub = (label, names) => ({ key: slug(label), label, icon: `${INT_ICON}/${slug(label)}.png`, games: names.map(g) });

/* ── real-ish game-name pools (reused across categories, as the reference does) ── */
const MAC88 = ['Amar Akbar Anthony', '3 Cards Judgement', 'Queen Race', 'Race 20-20', 'Casino War',
  'Worli Matka', 'Trio', 'Bollywood Casino', 'Dus Ka Dum', 'One Card 20-20', 'One Card One Day',
  'Race To 17', 'Note Number', 'Center Card', 'High Card', 'Football Studio Dice', 'Cricket Battle', 'Marble Run'];
const DRAGON = ['Dragon Tiger', '1 Day Dragon Tiger', '20-20 Dragon Tiger', 'One Day Dragon Tiger',
  '2020 Dragon Tiger', 'Super Dragon Tiger', 'Bengali Dragon Tiger', 'Dragon Tiger Lion', '2 Cards Dragon Tiger',
  'Dragon Tiger 2', 'Speed Dragon Tiger', 'Muflis Dragon Tiger'];
const ROULETTE = ['Lightning Roulette', 'Speed Roulette', 'Auto Roulette', 'Diamond Roulette', 'Namaste Roulette',
  'Double Ball Roulette', 'American Roulette', 'European Roulette', 'Instant Roulette', 'Turkish Roulette',
  'Speed Auto Roulette', 'XXXtreme Lightning Roulette'];
const TEENPATTI = ['Teen Patti', '20-20 Teen Patti', '1 Day Teen Patti', 'Muflis Teenpatti', 'Bengali Teen Patti',
  'Teen Patti Test', '2 Card Teen Patti', 'Casino Teen Patti', 'Instant Teen Patti', 'King Teen Patti',
  'Teen Patti Open', '6 Player Teen Patti'];
const ANDAR = ['Andar Bahar', 'Andar Bahar 2', 'Goa Andar Bahar', 'Classic Andar Bahar', 'Casino Andar Bahar',
  'Live Andar Bahar', 'Super Andar Bahar', 'Instant Andar Bahar', 'Andar Bahar 20-20', 'Ultimate Andar Bahar',
  'Andar Bahar Fast', 'Royal Andar Bahar'];
const BACCARAT = ['Baccarat', '2020 Baccarat', '1 Day Baccarat', 'No Commission Baccarat', 'Speed Baccarat',
  'Lightning Baccarat', 'Dragon Baccarat', 'First Person Baccarat', 'Bengali Baccarat', 'Marina Baccarat',
  'VIP Baccarat', '32 Cards'];
const CRASH = ['Aviator', 'JetX', 'Crash', 'Rocketon', 'Cash Show', 'Aviatrix', 'Jet3', 'Space XY',
  'Big Bass Crash', 'Plinko X', 'Balloon', 'Ballon Race'];
const LIVE = ['Lightning Dice', 'Crazy Time', 'Monopoly Live', 'Dream Catcher', 'Mega Wheel', 'Sic Bo',
  'Lucky 7', 'Hi Low', 'Cricket War', 'Poker', 'Lottery', 'Bollywood Casino', '32 Cards', 'Worli Matka', 'Card Rummy'];

export const CASINO_CATEGORIES = [
  {
    key: 'all', label: 'ALL',
    subtabs: [sub('others', MAC88), sub('dragon tiger', DRAGON), sub('roulette', ROULETTE)],
  },
  {
    key: 'fantasy11', label: 'FANTASY11',
    subtabs: [sub('others', MAC88), sub('teen patti', TEENPATTI), sub('andar bahar', ANDAR)],
  },
  {
    key: 'mac88-live', label: 'MAC88 LIVE',
    subtabs: [sub('others', LIVE), sub('roulette', ROULETTE), sub('baccarat', BACCARAT)],
  },
  {
    key: 'aviator', label: 'AVIATOR',
    subtabs: [sub('others', CRASH), sub('crash', CRASH), sub('instant', [...CRASH.slice(0, 8), ...LIVE.slice(0, 6)])],
  },
  {
    key: 'live-casino', label: 'LIVE CASINO',
    subtabs: [sub('others', LIVE), sub('dragon tiger', DRAGON), sub('baccarat', BACCARAT)],
  },
];

export const CASINO_MARQUEE =
  "🎰 Welcome to Reddy Anna Book Casino — 89+ live casino games, instant deposits & 24/7 support 🎲";
